module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter04"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/004TOC#chapter_04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thirteen Years Earlier")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Elena")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Elena was furious when Sam moved out. She knew it was her mother’s fault. If Suzanne had been nicer to him, if she had played up to him, he would not have left them. She knew he had had an affair with a client. She had listened with a glass at the wall to her parents’ fighting. Not that Sam was her father, but he was better than most fathers. Suzanne should have fought for him, got dressed up, had her hair done over, sat in his lap and told him how wonderful he was. Instead she stupidly blamed him for being unethical, as if ethics had anything to do with sex. Even Elena knew that was garbage, and she was still a stupid virgin at fourteen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even her cat Big Boy missed Sam, whose lap he liked to sit in. Everything was falling apart in her life. Her two best girlfriends, Genette and Helen, were no longer hers. Ever since they’d moved to the South End when she was just entering the first grade, Helen had been her other self. Helen was Black, but they had the same name in different forms, and Helen’s mama was a lawyer too. Genette transferred in at the beginning of third grade. Helen was closer to Genette than Elena was, but they all hung together, inseparable in and after school. She learned all her jump rope chants from them. Then around the time they were all going to take their exams to go to Boston Latin School, Helen’s family moved to Lexington. Elena saw her a couple of times after that, and they called and wrote, but their closeness gradually died. Genette had gotten interested in boys, and her grades were suffering. She didn’t make the cut. Elena went on to Boston Latin alone, and Genette got into a crowd in her middle school.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even though Elena was in seventh grade, at Boston Latin she was called a sixie, and they were the bottom of the heap. The school went through twelfth grade, and the older kids were so sophisticated and knowing, they were always picking on the sixies. Elena had begun to grow tall, so she wasn’t towered over like most of her class, but that didn’t keep her from being a target. The first year, she tried hanging with the Latina girls, but she was studying for her bat mitzvah, and that set her apart. She wasn’t about to pretend she wasn’t Jewish.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So far, she had done it all right, the way she was supposed to. Her mother kept telling her that Boston Latin was the place she had to be, like a private school except it didn’t cost anything. That was a big help after the divorce, since her mother had to buy Sam out of the row house they lived in on Rutland Street. She had gotten As in everything but math. Like her grandma, she liked languages. She was taking Latin because she had to and Spanish because she wanted to. She got through algebra only because the guy sitting next to her let her cheat off his papers. That was Evan, who lived in the South End too on West Newton, although he’d gone to a different grade school. Evan was almost as dark as she was and Jewish too. He was great at math, and in ninth grade, he took a science prize. He was skinny and wore glasses and refused not only to go out for sports but to take football or basketball seriously. Boston Latin was big on sports in spite of being an elite school: their traditional rivalry was the Thanksgiving football game with Boston English. Evan and Elena decided not to attend. It was like going on strike. They went to a slash movie instead and sat there laughing, making bets on who would get cut up next.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The first time they had sex, they were stoned and kept giggling. It didn’t hurt, but it didn’t feel like much. They didn’t date like the straight kids. Both his parents worked, and her mother was always at the law office or in court, so they just fucked whenever they felt like it. When Rachel was home from grade school, Elena and Evan just went in Elena’s room and shut the door. They played music loud. She had Rachel cowed. She knew even if Rachel suspected anything, she wouldn’t tell Suzanne: she’d be scared to. Evan put on his father’s overcoat and went into an adult bookstore. He bought two books about sex and several videos. After that, he spent an hour looking for her clitoris till he found it.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If other girls asked her about him, she said he was like her brother. They were alike, intense and dark and singular: more than her brother or her lover, Evan was her twin. They liked the same thrash bands that drove adults frothing insane. They also liked some alternative groups. They liked dark violent movies that felt real. They liked taking their clothes off and trying different things. They always did their homework together and they always had sex, using a condom. They went through a couple of packs every week. Neither of them could drive a car, for they were both fourteen. They had to use their bikes or the MBTA to go anywhere. They bought their dope in the neighborhood, at a spot outside a drugstore where guys she knew from grade school were selling. Evan lived in a brick row house a story shorter than hers, but his family had the whole place except for the basement apartment. Both of them loved their neighborhood, with its blocks that matched, each block a particular type of row house, but every one of them individual too, all red brick and some with funky little strip gardens in the middle of the street.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Evan and she didn’t talk garbage like love and families. They talked about peace and death and hypocrisy and lies. They did his next science project together, and then they let the mice go in the basement of the school. She hoped they could make it on their own.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("She listened to the other girls talking about their boyfriends, and it wasn’t like that with her. She wasn’t crazy about Evan. She didn’t dote on him. It was as if they were each other’s shadow. He called them E squared or E to the second power. There was no hand holding, no smooching, no rings or pins or flowers. They fought sometimes and called each other names, but it never lasted. They would start laughing, as if for them to be anything but one being, one conspiracy, one gang of two was a joke. She could not even have said if she loved Evan. It was like loving her arm. They were a unit. His parents and her mother asked questions, but they had no idea how much time the two of them spent together. Their grades stayed high. She thought sometimes that if she robbed banks, it would be okay with Suzanne, just so long as she maintained her grade point average and stayed in Boston Latin. Suzanne was always telling her how lucky she was to be there, but she didn’t fit in. She was too weird for the other girls. She was always an outsider, and if she stood with a group of girls, conversation slowed down or even ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("stopped. She got her breasts and she was tall, so guys were always trying to feel her up, poking at her, making noises, but they were scared of her too and never bugged her about dating.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Evan and she could talk about everything. They talked about being Jewish. He told her, “My grandma made it something important, beautiful. My parents, it’s like something they stepped in and if only they scrape hard enough, they can get rid of it. Last year they had me get bar-mitzvahed, but it was like this meaningless thing. My grandma had just died and I felt shitty, and all they could think about was how much the party was costing and who was the right caterer and who to invite and who to leave out and who gave the best presents. It was gross. They’re gross. Don’t take it seriously if it doesn’t make money.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not into the religion. I want to have both my heritages. Sometimes I wish I knew more about Sephardic Jews. My aunt Karla, she told me that’s what I look like, and she told me something about them. They speak Ladino instead of Yiddish. She’s got this adopted daughter, Rosella, who I think looks a little like me. When people see us together when they’re visiting or we go to Brooklyn, they think we’re sisters.” Sephardic Jews seemed to Elena much more romantic than Ashkenazi like her family. She read a historical novel about the Spanish Inquisition and conversos, and it was cool and frightening and epic. Elena did not bother to explain to Evan that Rosella was really Puerto Rican, because that was less interesting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("The next year there was a new student who transferred in from Kansas. They both had history with him. He wasn’t a jock, a club kid, one of the super students who ran the school, or a burnout who would be tossed, but like them, one of the weird kids. He was between them in height and had pale sleek blond hair he wore to his shoulders. His eyes were a dark haunting blue. He had a scar through one light brown eyebrow. His cheekbones were high and sharp, and his profile looked to her as if it should be carved on the prow of a sailing vessel. He always had shadows of stubble on his cheeks that made him seem older, more experienced. Half the guys had just started shaving. Evan had a darkish beard but not much of it. He only had to shave every other day, and it took him about a minute, although she did like to watch, ’cause it was such a male thing to do. She was almost hairless on her body and never ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("even shaved her legs. To each other, they called the new kid the Decadent Viking. “I want him,” Evan said.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So do I,” she said. “We’ll share him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They made up stories of capturing him, tying him up and doing things to him. His name was Chad. It seemed a silly name for such a fascinating-looking guy. He was broody. He sat at the back, and even when he knew the answers, he sounded as if he resented being right. She sat down next to him in assembly one day. His wrists stuck out below his shirt. There was a scar on each of them. He caught her looking at his wrists. They stared at each other. He did not hide his wrists. Then he smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For two months they didn’t do anything more than make up stories about Chad the Decadent Viking. Then Evan asked him one day, “Want to study for finals in history with Elena and me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is she your girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t even know what that means….”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They went over to Evan’s house. He didn’t have a pesky kid sister, only an older brother, at William and Mary. For the first hour they studied together up in Evan’s room, smoking cigarettes and dope and studying really hard, but she knew Evan was planning something. It made her feel tense and high. She trusted Evan and she didn’t care what he did, as long as Chad didn’t laugh at them. She got excited just sitting there, knowing that Evan was about to make his move.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stood up suddenly and came over to her, drawing her to her feet. He began unbuttoning her blouse. “Get undressed, Elena, and lie on the bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chad remained in his chair. “Hey. What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Watch,” was all Evan said. He waited till she had stripped and lay on the bed, feeling exposed but also high from the way that Chad was staring at her. She knew that she looked good and that he couldn’t turn his eyes away. In the meantime, Evan quickly undressed and put on a condom. Then he lay down on top of her. He could tell she was excited already and simply pushed in and began to fuck her. She glanced over at Chad. He was staring at them, but he hadn’t moved. She loved the feeling of him watching them, as if he was in their power and couldn’t break away. She came quickly. So did Evan.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("He stood up, not covering himself, and came to stand in front of Chad. He motioned for Elena to come over. Slowly, loose and wet after ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("coming, she obeyed. She almost felt sorry for Chad. Instead of looking cool and in command the way he always did, he looked lost, almost scared, but he stood his ground. She had no idea what Evan was about to do, and in a way she was scared too, but she trusted him. It would be something wild. She thought Evan was enjoying the upper hand and the power to shock Chad.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you want us?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chad was so startled he couldn’t reply for a moment. Then he repeated, “Us?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We come as a set. We don’t separate. Or are you scared?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I never did it with a guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knew Evan hadn’t either, but he wasn’t going to say so, and she wouldn’t betray him. “Have you ever done it with a girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Once…” Chad said reluctantly. His gaze returned to her body. His eyes excited her. Evan never looked at her that way. They were so used to each other’s bodies, they took their nakedness as a matter of course. Anyhow in the year they had been fucking, her body had changed. She had real breasts now, and her behind was curvier. She liked Chad staring at her. Chad raised his gaze to look into her eyes. “Don’t you have a will of your own?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re together,” Elena said indignantly. “He doesn’t make me do what I don’t want to. We’re honest with each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you love Evan?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elena took a step backward away from Chad, shaking back her hair. “I don’t know what that means.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chad grinned narrowly, as if she had given him back a measure of initiative. “But I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you don’t want to, nobody’s making you.” Elena made as if to reach for her T-shirt from a Twisted Sister concert.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He caught her wrist. He gave her a push so she sat down hard on the edge of the bed. Then slowly and deliberately he undid his belt buckle and then his shirt and then his jeans. Evan watched him with his head cocked, smiling slightly. Chad was erect, so he couldn’t be that put off. She stared at his cock, because it was only the second one she had ever seen. He looked different from Evan, sort of bigger and looser around the top. “I’m not circumcised,” he said. “My father doesn’t believe in it.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Evan straddled his desk chair, keeping out of the way. Elena waited until Chad had undressed completely and sat on the bed’s edge next to her. Then without waiting for him to make a move, she slid toward him and, taking his face in her hands, gave him a sensuous tongue kiss. She moved her thigh against his. She wanted him so bad she ached. She did not think she had ever wanted Evan this strongly, but she would never let him know that. It would hurt his feelings, and he was her own. Her flesh. Her more than brother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chad’s hand was on her breast now, a little awkwardly, squeezing hard. With Evan she would have instructed him, but she could not take a chance on discouraging Chad. They had wanted him and now they were going to have him, both of them. Now he was lying on top of her, kissing her almost frantically. She put her hand on his prick and guided him in. Normally she would have liked fooling around with him longer, but she did not want anything to go wrong. He thrust hard and came almost at once, long before she could. Then he lay spent on the bed, while she eased out from under him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Evan let him lie like that for several minutes. Then he motioned for her to get up. She took the desk chair, which Evan had dragged to just beside the bed to watch more closely. Evan lay down beside Chad. At first he just caressed him from the back, making spoons. Evan’s chest and pubic hair were dark, almost black, and Chad’s body hair was the palest brown. Chad was tanned over his arms and chest. Evan was milky pale. Evan patiently caressed Chad, reaching around to his cock. Then he rolled Chad onto his stomach, used the surgical jelly and slowly, caressing his way, put himself into Chad’s ass. Chad winced and bit at the pillow, but once Evan was in, he seemed to mind it far less. She liked watching. She loved watching. She was possessing Chad through Evan’s cock. She was fucking him through Evan. She wanted Evan to thrust harder, but he was careful, gentle. She could almost feel his come. Then he rested for a moment, turned Chad over and began to suck his cock. She came just watching them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Afterward Chad lay as if dazed. “Do you do this a lot?” he asked finally, trying to recover himself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We fuck all the time,” Evan said. “We study and we fuck. But it’s the first time we’ve ever taken anybody else with us. You should consider it an honor.” He was grinning widely.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you like being with us?” Elena asked almost shyly. He was so beautiful, Chad with the blue blue eyes and the carved face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve spent worse afternoons.” He reached out and pulled her down on the bed with him. He was staring into her eyes. “I don’t understand you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sometimes I don’t understand myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a light caress now his hand moved over her breast. “You’re like something I made up lying in bed at night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She jerked away. “I’m no fantasy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Evan said, “You know, we could all have a lot of fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chad looked at him, his hand coming to rest on Elena’s bare thigh. “I think you’re right.”")])])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f6839d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008-chapter04.vue
// module id = 78
// module chunks = 0